import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function GDPRPage() {
  return (
    <>
      <Navbar />
      
      <div className="legal-page">
        <div className="legal-page-header">
          <div className="container">
            <h1 className="legal-title">GDPR - Protecția Datelor cu Caracter Personal</h1>
            <p className="legal-updated">Ultima actualizare: Ianuarie 2026</p>
          </div>
        </div>

        <div className="legal-content">
          <h2>1. Ce Este GDPR?</h2>
          <p>
            GDPR (General Data Protection Regulation) sau în română <strong>Regulamentul General privind Protecția Datelor</strong> 
            (RGPD) este o legislație europeană (UE 2016/679) care a intrat în vigoare pe 25 mai 2018.
          </p>
          <p>
            <strong>Scopul GDPR:</strong> Să protejeze drepturile fundamentale ale persoanelor fizice cu privire 
            la prelucrarea datelor lor personale și să armonizeze legislația din UE.
          </p>
          <p>
            NEUROS EUROPE S.R.L. ("Brain Event") respectă în totalitate cerințele GDPR și ale legislației 
            române aplicabile (Legea 190/2018).
          </p>
          <h2>2. Drepturile Tale conform GDPR</h2>
          <p>
            GDPR îți conferă următoarele drepturi asupra datelor tale personale:
          </p>

          <div className="gdpr-rights">
            <div className="gdpr-right-item">
              <h3>Dreptul de Acces (Art. 15 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Poți solicita o copie a tuturor datelor personale pe care le deținem despre tine.</p>
              <p><strong>Ce primești:</strong></p>
              <ul>
                <li>Confirmarea că prelucrăm date despre tine</li>
                <li>O copie a datelor în format structurat (PDF sau Excel)</li>
                <li>Informații despre scopul prelucrării</li>
                <li>Lista destinatarilor datelor tale</li>
                <li>Durata de păstrare a datelor</li>
              </ul>
              <p><strong>Termen de răspuns:</strong> Maximum 30 de zile (gratuit pentru prima solicitare)</p>
            </div>

                <div className="gdpr-right-item">
              <h3>Dreptul de Rectificare (Art. 16 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Poți solicita corectarea datelor inexacte sau completarea datelor incomplete.</p>
              <p><strong>Exemple:</strong></p>
                  <ul>
                    <li>Ai schimbat numărul de telefon</li>
                    <li>Ai o nouă adresă de email</li>
                    <li>Numele tău este scris greșit</li>
                  </ul>
              <p><strong>Termen de răspuns:</strong> Maximum 30 de zile</p>
                </div>

                <div className="gdpr-right-item">
              <h3> Dreptul la Ștergere - "Dreptul de a fi Uitat" (Art. 17 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Poți solicita ștergerea datelor tale în anumite condiții.</p>
              <p><strong>Când se aplică:</strong></p>
                  <ul>
                    <li>Datele nu mai sunt necesare pentru scopul inițial</li>
                    <li>Îți retragi consimțământul (ex: pentru marketing)</li>
                    <li>Te opui prelucrării și nu există motive legitime prevalente</li>
                    <li>Datele au fost prelucrate ilegal</li>
                  </ul>
              <p><strong>Când NU se aplică:</strong></p>
                  <ul>
                    <li>Avem obligații legale (ex: păstrarea facturilor 10 ani)</li>
                    <li>Pentru apărarea unor drepturi în instanță</li>
                  </ul>
              <p><strong>Termen de răspuns:</strong> Maximum 30 de zile</p>
                </div>

                <div className="gdpr-right-item">
              <h3>Dreptul la Restricționarea Prelucrării (Art. 18 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Poți solicita limitarea modului în care folosim datele tale.</p>
              <p><strong>Când se aplică:</strong></p>
                  <ul>
                    <li>Contești exactitatea datelor (restricționăm până la verificare)</li>
                    <li>Prelucrarea este ilegală, dar nu vrei ștergerea datelor</li>
                    <li>Nu mai avem nevoie de date, dar tu le ceri pentru apărarea unui drept</li>
                  </ul>
              <p><strong>Efect:</strong> Datele sunt "înghețate" - nu le mai folosim, dar nu le ștergem</p>
                </div>

                <div className="gdpr-right-item">
              <h3>Dreptul la Portabilitatea Datelor (Art. 20 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Poți primi datele tale într-un format structurat, utilizat în mod curent.</p>
              <p><strong>Condiții:</strong></p>
                  <ul>
                    <li>Se aplică doar datelor pe care le-ai furnizat tu direct</li>
                    <li>Prelucrarea se bazează pe consimțământ sau contract</li>
                    <li>Prelucrarea este automatizată</li>
                  </ul>
              <p><strong>Format:</strong> CSV, JSON, PDF (la alegerea ta)</p>
              <p><strong>Poți solicita:</strong> Transferul direct către alt operator (dacă este posibil tehnic)</p>
                </div>

                <div className="gdpr-right-item">
              <h3>Dreptul la Opoziție (Art. 21 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Te poți opune prelucrării datelor tale în anumite situații.</p>
              <p><strong>Când se aplică:</strong></p>
                  <ul>
                    <li>Marketing direct (opoziție absolută - respectăm imediat)</li>
                    <li>Prelucrare bazată pe interese legitime (evaluăm cazul)</li>
                    <li>Profilare în scop de marketing</li>
                  </ul>
              <p><strong>Cum te opui la marketing:</strong> Click pe "Dezabonare" din orice email</p>
                </div>

                <div className="gdpr-right-item">
              <h3>Dreptul de a Nu Fi Supus Deciziilor Automatizate (Art. 22 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Nu vei fi supus deciziilor luate exclusiv de algoritmi.</p>
              <p><strong>Notă:</strong> Nu folosim momentan sisteme automatizate de luare a deciziilor (ex: AI pentru aprobare comenzi).</p>
              <p><strong>Dacă vom implementa în viitor:</strong> Vei fi informat și vei putea solicita intervenția umană.</p>
                </div>

                <div className="gdpr-right-item">
              <h3>Dreptul de a Depune Plângere (Art. 77 GDPR)</h3>
              <p><strong>Ce înseamnă:</strong> Poți depune o plângere la autoritatea de supraveghere dacă consideri că drepturile tale au fost încălcate.</p>
              <p><strong>Autoritate competentă în România:</strong></p>
              <p>
                    <strong>ANSPDCP</strong> (Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal)
                  </p>
                  <ul>
                    <li><strong>Adresă:</strong> B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București</li>
                    <li><strong>Telefon:</strong> +40 318 059 211</li>
                    <li><strong>Email:</strong> anspdcp@dataprotection.ro</li>
                    <li><strong>Website:</strong> <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer">www.dataprotection.ro</a></li>
                  </ul>
              <p><strong>Recomandare:</strong> Înainte de a depune plângere, te încurajăm să ne contactezi pentru a rezolva problema.</p>
                </div>
              </div>
          <h2>3. Cum Îți Exerciți Drepturile?</h2>
              
          <h3>3.1. Metoda 1: Email</h3>
          <p>
                Trimite-ne un email la <strong>contact@brain-event.com</strong> cu:
              </p>
              <ul>
                <li>Subiect: "Solicitare GDPR - [Tipul Dreptului]"</li>
                <li>Descrierea clară a cererii tale</li>
                <li>Dovada identității (ex: copie CI/pașaport) - pentru a preveni accesul neautorizat</li>
              </ul>

          <h3>3.2. Metoda 2: Telefon</h3>
          <p>
                Sună-ne la <strong>+40 767 978 707</strong> (Luni-Vineri, 09:00-17:00)
              </p>

          <h3>3.3. Metoda 3: Poștă</h3>
          <p>
                Trimite o scrisoare recomandată la:<br />
                <strong>NEUROS EUROPE S.R.L.</strong><br />
                București, România<br />
                <em>Atenție: Departament Protecția Datelor</em>
              </p>

          <h3>3.4. Termenul Nostru de Răspuns</h3>
          <p>
                Vom răspunde cererii tale în termen de <strong>maximum 30 de zile</strong> de la primire.
              </p>
          <p>
                În cazuri complexe, putem extinde termenul cu încă 60 de zile, dar te vom informa în primele 30 de zile.
              </p>

          <h3>3.5. Este Gratuit?</h3>
          <p>
                <strong>Da</strong>, în principiu exercitarea drepturilor este gratuită.
              </p>
          <p>
                <strong>Excepție:</strong> Dacă solicitările sunt în mod vădit nefondate, excesive sau repetitive, 
                putem percepe o taxă rezonabilă sau refuza cererea.
              </p>
          <h2>4. Principiile GDPR pe Care le Respectăm</h2>
              
          <h3>4.1. Legalitate, Echitate și Transparență</h3>
          <p>
                Prelucrăm datele tale doar pe baze legale (consimțământ, contract, obligație legală) și îți 
                explicăm clar ce facem cu ele.
              </p>

          <h3>4.2. Limitarea Scopului</h3>
          <p>
                Colectăm datele doar pentru scopuri specifice, explicite și legitime. Nu le folosim ulterior 
                în moduri incompatibile cu aceste scopuri.
              </p>

          <h3>4.3. Minimizarea Datelor</h3>
          <p>
                Colectăm doar datele strict necesare pentru scopurile declarate. Nu cerem informații "din 
                curiozitate" sau "pentru orice eventualitate".
              </p>

          <h3>4.4. Exactitatea</h3>
          <p>
                Ne asigurăm că datele sunt corecte și actualizate. Te încurajăm să ne anunți dacă ceva s-a 
                schimbat.
              </p>

          <h3>4.5. Limitarea Păstrării</h3>
          <p>
                Păstrăm datele doar atât timp cât este necesar:
              </p>
              <ul>
                <li>Date facturare: 10 ani (obligație legală)</li>
                <li>Date marketing: până la retragerea consimțământului sau max 3 ani</li>
                <li>Date tehnice: max 12 luni</li>
              </ul>

          <h3>4.6. Integritate și Confidențialitate</h3>
          <p>
                Implementăm măsuri tehnice și organizatorice adecvate pentru securitatea datelor:
              </p>
              <ul>
                <li>Criptare SSL/TLS</li>
                <li>Servere securizate</li>
                <li>Acces restricționat (doar personal autorizat)</li>
                <li>Backup-uri regulate</li>
                <li>Monitorizare și audit</li>
              </ul>

          <h3>4.7. Responsabilitate</h3>
          <p>
                Suntem responsabili pentru respectarea GDPR și putem demonstra conformitatea (accountability).
              </p>
          <h2>5. Breșe de Securitate (Data Breaches)</h2>
              
          <h3>5.1. Ce Este o Breșă de Securitate?</h3>
          <p>
                O breșă de securitate înseamnă distrugerea, pierderea, modificarea, dezvăluirea neautorizată 
                sau accesul neautorizat la datele personale.
              </p>

          <h3>5.2. Obligațiile Noastre</h3>
          <p>
                Dacă identificăm o breșă care prezintă un risc pentru drepturile tale:
              </p>
              <ul>
                <li>Notificăm ANSPDCP în termen de <strong>72 de ore</strong></li>
                <li>Te notificăm pe tine <strong>fără întârziere nejustificată</strong> (dacă riscul este ridicat)</li>
                <li>Documentăm incidentul și măsurile luate</li>
              </ul>

          <h3>5.3. Ce Informații Vei Primi</h3>
          <p>
                În cazul unei breșe, îți vom comunica:
              </p>
              <ul>
                <li>Natura breșei</li>
                <li>Ce date au fost afectate</li>
                <li>Posibilele consecințe</li>
                <li>Măsurile luate pentru remediere</li>
                <li>Recomandări pentru protejarea ta</li>
              </ul>
          <h2>6. Transferuri Internaționale de Date</h2>
          <p>
                Unii furnizori ai noștri (ex: Stripe) pot stoca date în afara Spațiului Economic European (SEE).
              </p>
          <p>
                <strong>Garanțiile noastre:</strong>
              </p>
              <ul>
                <li>Transferăm date doar către țări cu decizie de adecvare UE sau</li>
                <li>Folosim Clauze Contractuale Standard (SCC) aprobate de Comisia Europeană sau</li>
                <li>Transferăm către furnizori certificați (ex: EU-US Data Privacy Framework)</li>
              </ul>
          <p>
                Pentru detalii, vezi <a href="/politica-de-confidentialitate">Politica de Confidențialitate</a>.
              </p>
          <h2>7. Împuterniciți / Procesatori de Date (Subcontractanți)</h2>
          <p>
                Este posibil ca datele dumneavoastră să fie prelucrate de <strong>împuterniciți (procesatori)</strong>
                care acționează exclusiv în numele Brain Event / NEUROS EUROPE S.R.L., inclusiv pentru:
              </p>
              <ul>
                <li>Procesare plăți (Stripe)</li>
                <li>Emitere facturi (FGO)</li>
                <li>Hosting website și platformă bilete</li>
                <li>Servicii email</li>
                <li>Analiză și marketing (Google, Meta, Hyros, Microsoft Clarity — după caz)</li>
              </ul>
          <p>
                <strong>Garanțiile noastre:</strong>
              </p>
              <ul>
                <li>Contracte GDPR-compliant cu toți procesatorii</li>
                <li>Verificarea măsurilor de securitate</li>
                <li>Obligația de a prelucra datele doar conform instrucțiunilor noastre</li>
                <li>Obligația de confidențialitate</li>
              </ul>
          <h2>8. Evaluarea Impactului asupra Protecției Datelor (DPIA)</h2>
          <p>
                Pentru activități cu risc ridicat, efectuăm o Evaluare a Impactului asupra Protecției Datelor (DPIA).
              </p>
          <p>
                <strong>Momentan</strong>, activitățile noastre (vânzare bilete online) sunt considerate cu risc scăzut-mediu 
                și nu necesită DPIA obligatorie.
              </p>
          <p>
                Dacă vom implementa tehnologii noi (ex: AI, biometrie), vom efectua DPIA și te vom informa.
              </p>
          <h2>9. Responsabilul cu Protecția Datelor (DPO)</h2>
          <p>
                Conform GDPR, anumite organizații trebuie să desemneze un DPO (Data Protection Officer).
              </p>
          <p>
                <strong>NEUROS EUROPE S.R.L.</strong> nu este obligată legal să desemneze un DPO deoarece:
              </p>
              <ul>
                <li>Nu suntem autoritate publică</li>
                <li>Nu efectuăm monitorizare sistematică la scară largă</li>
                <li>Nu prelucrăm la scară largă categorii speciale de date</li>
              </ul>
          <p>
                <strong>Însă</strong>, avem un responsabil intern pentru protecția datelor pe care îl poți contacta 
                la <strong>contact@brain-event.com</strong>.
              </p>
          <h2>10. Minori (Sub 16 Ani)</h2>
          <p>
                Conform GDPR (Art. 8), pentru minori sub 16 ani, prelucrarea datelor necesită consimțământul 
                părintelui sau tutorelui legal.
              </p>
          <p>
                <strong>În România</strong>, vârsta minimă este stabilită la 16 ani conform Legii 190/2018.
              </p>
          <p>
                <strong>Politica noastră:</strong>
              </p>
              <ul>
                <li>Nu colectăm în mod conștient date de la persoane sub 18 ani fără acordul părinților</li>
                <li>Dacă descoprim că am colectat astfel de date, le vom șterge imediat</li>
                <li>Recomandăm ca un părinte/tutore să achiziționeze biletul pentru minor</li>
              </ul>
          <h2>11. Resurse Utile GDPR</h2>
              
          <h3>11.1. Autoritatea Națională (România)</h3>
          <p>
                <strong>ANSPDCP</strong> - Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal
              </p>
              <ul>
                <li><strong>Website:</strong> <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer">www.dataprotection.ro</a></li>
                <li><strong>Telefon:</strong> +40 318 059 211</li>
                <li><strong>Email:</strong> anspdcp@dataprotection.ro</li>
              </ul>

          <h3>11.2. Comisia Europeană</h3>
          <p>
                <strong>Platforma europeană GDPR:</strong> <a href="https://ec.europa.eu/info/law/law-topic/data-protection_en" target="_blank" rel="noopener noreferrer">ec.europa.eu/info/law/law-topic/data-protection</a>
              </p>

          <h3>11.3. European Data Protection Board (EDPB)</h3>
          <p>
                <strong>Ghiduri și recomandări GDPR:</strong> <a href="https://edpb.europa.eu" target="_blank" rel="noopener noreferrer">edpb.europa.eu</a>
              </p>
          <h2>12. Contact</h2>
          <p>
                Pentru orice întrebări despre GDPR, drepturile tale sau modul în care prelucrăm datele:
              </p>
              <ul>
                <li><strong>Email:</strong> contact@brain-event.com</li>
                <li><strong>Telefon:</strong> +40 767 978 707</li>
                <li><strong>Adresă:</strong> București, România</li>
              </ul>
          <p>
                <strong>Subiect email recomandat:</strong> "Solicitare GDPR - [Tipul Dreptului]"
              </p>
          <div className="legal-footer">
            <p>
              <strong>Angajamentul nostru:</strong> Respectăm și protejăm drepturile tale conform GDPR. 
              Transparența și securitatea datelor tale sunt prioritățile noastre!
            </p>
          </div>
          </div>
        </div>

      <Footer />
    </>
  );
}

export default GDPRPage;

